// ============================================================
// CTA.js - "Ready to Partner" call-to-action section
// ============================================================

import React from "react";
import { CONTACT_INFO } from "../data";

function CTA() {
  return (
    <section className="cta-section" id="contact">
      <div className="cta-box">
        <h2>Ready to Partner with WHANI?</h2>
        <p>Contact us for enquiries, quotations, project support, or partnerships</p>

        <div className="cta-buttons">
          {/* Email Button */}
          <a href={`mailto:${CONTACT_INFO.email}`} className="btn-primary">
            Get in Touch →
          </a>

          {/* WhatsApp Button */}
          <a
            href={CONTACT_INFO.whatsapp}
            target="_blank"
            rel="noreferrer"
            className="btn-whatsapp"
          >
            WhatsApp Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default CTA;
